export class ListDataCatalogChildrenRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogChildrenRequest.attributeTypeMap;
    }
    constructor() {
    }
}
